import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import {
  CombinedGraphQLErrors,
  CombinedProtocolErrors,
  ServerError,
  ServerParseError,
} from '@apollo/client/errors';

import { LoggingService } from '@customer-portal/core';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private loggingService: LoggingService) {
    super();
  }

  override handleError(error: Error): void {
    // eslint-disable-next-line no-console
    console.log(error);

    const isApolloError =
      CombinedGraphQLErrors.is(error) ||
      CombinedProtocolErrors.is(error) ||
      ServerError.is(error) ||
      ServerParseError.is(error);

    if (error instanceof HttpErrorResponse || isApolloError) {
      // Ignore HTTP errors
      return;
    }

    this.loggingService.logException(error);
  }
}
